import Operations from './operations.graphql'
import Misc from './misc.graphql'

export default """
	#{Misc}

	#{Operations}
"""
